import { render } from "./Select.vue?vue&type=template&id=3c9ee804"
import script from "./Select.vue?vue&type=script&lang=js"
export * from "./Select.vue?vue&type=script&lang=js"
script.render = render

export default script